<!--
 * @Descripttion: 
 * @version: 国际化语言切换组件
 * @Author: dengyao
 * @Date: 2023-11-28 15:23:45
 * @LastEditors: sueRimn
 * @LastEditTime: 2023-12-06 17:32:45
-->
<template>
  <Dropdown :trigger="['click']">
    <a class="lang-switch" @click.prevent>
      {{ LangType[settingStore.locale] }}
    </a>
    <template #overlay>
      <Menu @click="handleMenuClick" class="menu">
        <MenuItem key="zh" class="menu-item"> CN </MenuItem>
        <MenuItem key="en" class="menu-item"> EN </MenuItem>
        <MenuItem key="id" class="menu-item"> ID </MenuItem>
      </Menu>
    </template>
  </Dropdown>
</template>
<script lang="ts" setup>
import { Dropdown, Menu, MenuItem } from 'ant-design-vue'
import type { MenuProps } from 'ant-design-vue'
import { useSettingStore } from '@/store/sysSetting'
import LangType from '@/utils/enums/LangType'
import { dictService } from '@/service/api'
import { useApi } from '@tmp/site-common'
import { isSuccess } from '@/utils'

interface Props {
  /**是否重载页面 */
  reload?: boolean
}
const props = defineProps<Props>()
const settingStore = useSettingStore()

const { fetchData, result } = useApi(dictService.getI18n)
fetchData().then((res: any) => {
  if (!isSuccess(res)) return
  settingStore.langJson = result.value
})

type Lang = keyof typeof LangType

const handleMenuClick: MenuProps['onClick'] = async (e) => {
  settingStore.locale = e.key as Lang
  const obj = {
    id: {},
    en: {}
  }
  const res = await fetchData()
  if (!isSuccess(res)) return
  obj[e.key] = result.value
  settingStore.langJson = obj[e.key]
  if (props.reload) {
    location.reload()
  }
}
</script>
<style lang="less" scoped>
.lang-switch {
  height: 32px;
  line-height: 32px;
  width: 56px;
  text-align: center;
  border-radius: 20px;
  background-color: @white;
  color: @primary-color;
  display: inline-block;
}
</style>
